<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo</label>
                    <div class="field-label field-label-center">{{ objEdicao.xsequencia }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Data Lançamento</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objEdicao.dtlancamento) }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo Vistoria</label>
                    <div class="field-label field-label-center">{{ objEdicao.xsequencia_pla06 }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Data Vistoria</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objEdicao.dtvistoria) }}</div>
                </div>
                <div class="form-item">
                    <label class="label-caption">Status</label>
                    <div class="field-label">{{ objEdicao.xstatus }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label field-label-start">{{ objEdicao.nmestabelecimento }}</div>
                </div>
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
    </div>
    

    <div v-for="item in lsItens" :key="item.id" class="form-edit-page row-space">
        <div class="tela-dividida row-space">
            <div class="coluna">
                <div class="form-item-char15">
                    <label class="label-caption">PAC</label>
                    <div class="field-label field-label-center field-label--destaque">{{ item.nmpac }}</div>
                </div>

                <div class="form-item-char15">
                    <label class="label-caption">Prazo</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(item.dtprazo) }}</div>
                </div>                
            </div>

            <div class="coluna">
                <div class="form-item-char15">
                    <label class="label-caption">Data Prevista</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(item.acdtprevista) }}</div>
                </div> 
                
                <button v-if="item.conferir && perfilCorreto" class="btn-confirm" @click="confirmarItem(item)">CONFIRMAR</button>
            </div>
        </div>
        

        <div class="tela-dividida">
            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Não Conformidade</label>
                    <textarea v-model="item.pacobs" rows="5" maxlength="3000" readonly/>
                </div>
            </div>

            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Ação Corretiva</label>
                    <textarea v-model="item.acdetalhamento" rows="5" maxlength="3000" readonly/>
                </div>
            </div>
        </div>
    </div>


    <div class="row-end">
        <button class="btn-cancel" @click="confirmaReabertura">Reabrir Digitação</button>
        <button v-if="perfilCorreto" class="btn-cancel" @click="encerrarDigitacao">Encerrar e Assinar</button>
    </div>

    <ConfirmModal ref="confirmModal" />
    
    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />

    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const confirmModal = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const msgAlerta = ref(null);
const msgOkModal = ref('Relatório encerrado e homologado com sucesso.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref({});
const perfilCorreto = ref(false);
const showOkModal = ref(false);

const closeForm = () => {
    emit('save');
    emit('close'); 
};

async function confirmaReabertura() {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma reabertura do relatório para digitação?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        reabrirDigitacao();
    }
}

async function encerrarDigitacao(){
    try{
        if (lsItens.value.filter(a => a.conferir).length > 0) throw new Error('Necessário "CONFIRMAR" todos os ítens');
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;
        
        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:PLA08|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.xsequencia}`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objEdicao.value.id;
        objAssinatura.value.doc_tipo = 'PLA08';

        const respAss = await Api.genericPut('/pla/assinar', objAssinatura.value);
        if (respAss.bolok === 1){
            showOkModal.value = true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        
        if (!objEdicao.value.id){
            // SELECIONA OBJETO PRINCIPAL
            const rPla08 = await Api.genericPost('/lspla/pla08', {idep: globalStore.idep, id: props.idEdicao});
            objEdicao.value = rPla08[0];
            perfilCorreto.value = 
                (objEdicao.value.status === 2 && globalStore.ckperfilestabelecimento) ||
                (objEdicao.value.status === 3 && globalStore.ckperfilrt);
            if (!perfilCorreto.value) {msgAlerta.value = `ATENÇÃO: ${objEdicao.value.xstatus}`}
        }

        const rItens = await Api.genericPost('/lspla/pla08_itens', {id: props.idEdicao});
        lsItens.value = rItens.map(item => ({
            ...item,
            conferir: true
        }));

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
};

async function confirmarItem(obj) {
    try {
        obj.conferir = false;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
}

async function reabrirDigitacao(){
    try{
        isLoading.value=true;
        msgAlerta.value=null;

        const resp = await Api.genericPut('/pla/pla08', {
            id: objEdicao.value.id,
            idassinaturaestab: 0,
            idresponsavel: 0,
            nmresponsavel: '',
            idassinaturart: 0,
            idrt: 0,
            nmrt: '',
            dhdigitacao: '',
            idusuario: globalStore.idusuario});
        if (resp.bolok === 1){
            msgOkModal.value = 'Relatório está reaberto para digitação!';
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${resp.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>

<style scoped>
.tela-dividida {
    display: flex;
    gap: 10px;
    box-sizing: border-box;
}

.coluna {
    flex: 1;
    display: flex;
    gap: 10px;
    align-items: end;
}

.esquerda {
    background-color: #3498db;
}

.direita {
    background-color: #2ecc71;
}
</style>
